import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class ProgressBarController implements angular.IComponentController {
    classed: string;
    progressValue: number;
    static $inject = [];

    $onInit() {
        if (!this.classed) {
            this.classed = 'progress-bar-success';
        }
    }
}

export const wtProgressBar: ComponentDefinition = {
    componentId: 'wtProgressBar',
    controller: ProgressBarController,
    template: require('./progressBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        classed: '@?',
        progressValue: '<'
    }
};
